module.exports = __webpack_public_path__ + "static/dashboard@1x-117b0f067423776ae197189a9de6f3cb.png";